import React, { useEffect, useState, useCallback } from "react";
import { useApp } from "../context/AppContext";
import { Boxes, ChevronDown, ChevronRight } from "lucide-react";

const money = (n) => "$" + Number(n || 0).toLocaleString();

export default function MaterialCostCard({ projectId }) {
  const { api, lang } = useApp();
  const zh = lang === "zh";
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);

  const load = useCallback(() => {
    api.get(`/projects/${projectId}/material-cost`).then((r) => setData(r.data)).catch(() => {});
  }, [api, projectId]);
  useEffect(() => { load(); }, [load]);

  if (!data || (!data.summary?.length && !data.detail?.length)) return null;

  return (
    <div data-testid="material-cost-card" className="mb-4 rounded-xl border border-emerald-200 bg-emerald-50/40 overflow-hidden">
      <button data-testid="material-cost-toggle" onClick={() => setOpen((v) => !v)} className="w-full flex items-center justify-between px-4 py-2.5">
        <span className="flex items-center gap-2 text-sm font-semibold text-emerald-800">
          <Boxes className="h-4 w-4" />{zh ? "材料成本明细" : "Material Cost"}
          <span className="text-[11px] text-emerald-600 font-normal">{data.summary.length} {zh ? "种材料" : "SKU"}</span>
        </span>
        <span className="flex items-center gap-2">
          <span className="text-base font-bold text-emerald-700" data-testid="material-cost-total">{money(data.total)}</span>
          {data.pct != null && <span data-testid="material-cost-pct" className={`text-[11px] font-semibold px-1.5 py-0.5 rounded-full ${data.pct > 100 ? "bg-red-100 text-red-600" : data.pct > 60 ? "bg-amber-100 text-amber-700" : "bg-emerald-100 text-emerald-700"}`}>{zh ? "占合同额 " : ""}{data.pct}%</span>}
          {open ? <ChevronDown className="h-4 w-4 text-emerald-600" /> : <ChevronRight className="h-4 w-4 text-emerald-600" />}
        </span>
      </button>
      {open && (
        <div className="bg-white border-t border-emerald-100">
          <table className="w-full text-xs">
            <thead className="bg-slate-50 text-slate-500"><tr>
              <th className="text-left px-3 py-1.5">{zh ? "材料" : "Material"}</th>
              <th className="text-right px-3 py-1.5">{zh ? "累计数量" : "Qty"}</th>
              <th className="text-right px-3 py-1.5">{zh ? "成本" : "Cost"}</th>
            </tr></thead>
            <tbody className="divide-y divide-slate-100">
              {data.summary.map((r) => (
                <tr key={r.key} data-testid={`material-cost-row-${r.key}`}>
                  <td className="px-3 py-1.5 text-slate-700">{r.name}<span className="text-slate-400 ml-1">{r.unit}</span></td>
                  <td className="px-3 py-1.5 text-right">{r.qty}</td>
                  <td className="px-3 py-1.5 text-right font-medium text-slate-800">{money(r.cost)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="px-3 py-2 border-t border-slate-100 text-[11px] text-slate-500">
            {zh ? "含仓库出库与直送现场，退料自动回冲。已同步至财务中心项目成本。" : "Includes issues & direct-to-site; returns auto-reversed."}
          </div>
        </div>
      )}
    </div>
  );
}
